import Decimal from 'decimal.js'

/**
 * Function to calculate the final price based on daily price, period, and exchange rate
 * @param {number} dailyPrice - The daily price
 * @param {number} period - The period for which the price is calculated
 * @param {number} exchangeRate - The exchange rate to apply
 * @returns {number} - The final calculated price
 */

export function calculateFinalPrice(dailyPrice, period, exchangeRate) {
  const price = new Decimal(dailyPrice)

  const prices = {
    day: price,
    hour: price.div(24),
    month: price.mul(30),
    threeMonths: price.mul(30).mul(3),
    sixMonths: price.mul(30).mul(6),
    year: price.mul(30).mul(12),
  }

  let selectedPrice
  switch (period) {
    case 1:
      selectedPrice = prices.day
      break
    case 30:
      selectedPrice = prices.month
      break
    case 90:
      selectedPrice = prices.threeMonths
      break
    case 180:
      selectedPrice = prices.sixMonths
      break
    case 365:
      selectedPrice = prices.year
      break
    default:
      selectedPrice = prices.hour
      break
  }

  let result = selectedPrice.mul(exchangeRate)
  result = result.toDecimalPlaces(5, Decimal.ROUND_DOWN)
  const multiplier = new Decimal(100)
  result = result.mul(multiplier).ceil().div(multiplier)

  return result.toFixed(2)
}

/**
 * Function to map frontend periods to backend periods
 * @param {number} period - The period from initialStore
 * @returns {number} - The corresponding period for the backend
 */

export function mapPeriodToBackend(period) {
  switch (Number(period)) {
    case 1:
      return -50 // one day
    case 30:
      return 1 // one month
    case 90:
      return 3 // three months
    case 180:
      return 6 // six months
    case 365:
      return 12 // one year
    default:
      return -50 // default to one day
  }
}
